export default {"src":"/_next/static/media/rightArrow.47a41b0b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};